import { namespace } from 'vuex-class';
import { IAddPageState } from '@/dealroom/add-page/store/add-page.types';

export const AddPage = namespace('dealroom/addPage');

export const state: IAddPageState = {
  contentType: null,
};

export enum EAddPageMutation {
  SetState = 'setState',
}

export enum EAddPageAction {
  SetDefaultState = 'setDefaultState',
}
